import React, { createRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Tooltip } from '../../../../components';
import useClasses from '../../../../hooks/useClasses';

import './style.scss';

const WEEKDAYS = 7;

interface Props {
  unlockDate: Date;
  info?: string;
  className?: string;
}

const ParagraphPhaseUnlockDate: React.FC<Props> = (props) => {
  const {
    unlockDate,
    info,
    className,
  } = props;

  const ref = createRef<HTMLDivElement>();
  const { t } = useTranslation();
  const { buildClass, joinClasses } = useClasses('ParagraphPhaseUnlockDate');

  const renderUnlockDate = useMemo(() => {
    const translationBase = 'paragraphs.phase.unlock_date';
    const timeUntilUnlockDate = unlockDate.getTime() - new Date().getTime();
    const daysUntilUnlockDate = Math.ceil(timeUntilUnlockDate / (24 * 60 * 60 * 1000));

    // Unlock date is within one week.
    if (daysUntilUnlockDate <= WEEKDAYS) {
      return t(`${translationBase}_relative`, { days: daysUntilUnlockDate });
    }

    return t(`${translationBase}`, {
      unlockDate,
      formatParams: {
        unlockDate: {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        },
      },
    });
  }, [unlockDate, t]);

  return (
    <div className={joinClasses(buildClass(), className)}>
      <Icon icon="info" variant="7" />
      <time dateTime={unlockDate.toISOString()}>{renderUnlockDate}</time>

      {info && (
        <Tooltip targetRef={ref}>
          {info}
        </Tooltip>
      )}
    </div>
  );
};

export default ParagraphPhaseUnlockDate;
